import React from "react";
import moment from "moment";

import {
  Container,
  ItemDetails,
  Left,
  Right,
  Legend,
  Details,
  IconInformation,
} from "./styles";
import information from "~/assets/images/information.svg";

function Item({options, data, openModal}) {

  return (
    <Container
      className="mb-3"
      style={{ cursor: !data.paymentTypeBoleto ? "pointer" : "normal" }}
    >
      <Left>
        <Legend>Solicitação <u>{data.code}</u></Legend>
        <ItemDetails style={{ justifyContent: "start", width: 100 }}>
          <span
            style={{
              fontSize: "10px",
              color:
              data.status === "Aceita"
                  ? "#75B943"
                  : data.status === "Negada"
                  ? "#e34e2a"
                  : data.status === "Em Análise"
                  ? "#f0b01b"
                  : "#000",
            }}
            className="mdi mdi-checkbox-blank-circle mr-1"
          />
          {data.status}
        </ItemDetails>
        <ItemDetails>
          {data.date && (
            <>
              <Legend>Data:</Legend>{" "}
              { moment(data.date).format("DD/MM/YYYY") }
            </>
          )}
        </ItemDetails>
      </Left>

      <Right>
        { data.schedule && (
          <Legend style={{ paddingRight: 100 }}>
            Horário: {data.schedule}
          </Legend>
        )}
        { data.status === "Aceita" ? (
          <Legend style={{ paddingRight: 20 }}>
            {(options && data.object) ? (options.find((item) => item.value === data.object)?.label || data.object ) : data.object }
          </Legend>
        ) : (
            <Details onClick={() => openModal()}>
              Detalhes
              <img src={information} style={IconInformation} alt="" />
            </Details>
        )}
      </Right>
    </Container>
  );
}

export default Item;
